import { render, staticRenderFns } from "./manage-assignment-breakdown.vue?vue&type=template&id=57de5b0c&scoped=true"
import script from "./manage-assignment-breakdown.vue?vue&type=script&lang=js"
export * from "./manage-assignment-breakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57de5b0c",
  null
  
)

export default component.exports